<template>
  <main>
    <div class="breadcrumb">
      <div class="container">
        <ul>
          <li><router-link to="/">HARUMIFLAG</router-link></li>
          <li><router-link to="/contact/form">お問い合わせフォーム</router-link></li>
        </ul>
      </div>
    </div>
    <div class="contact">
      <div class="contact__title">
        <div class="container">
          <h2>お問い合わせ</h2>
          <ul class="contact__process step2">
            <li>
              <span>1.入力</span>
            </li>
            <li class="active">
              <span>2.確認</span>
            </li>
            <li>
              <span>3.完了</span>
            </li>
          </ul>
          <p>お問い合わせ内容ご確認の上、「送信する」ボタンを押してください</p>
        </div>
      </div>
      <div class="contact__content">
        <div class="container">
          <form class="form form--confirm" @submit.prevent="submitComplete">
            <!-- fullname -->
            <div class="form__row">
              <div class="form__title">
                <label>氏名<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.name + ' ' + this.$props.data?.contact_meta.first_name }}</p>
              </div>
            </div>
            <!-- company -->
            <div class="form__row">
              <div class="form__title">
                <label>法人団体名</label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.company }}</p>
              </div>
            </div>
            <!-- email -->
            <div class="form__row">
              <div class="form__title">
                <label>メールアドレス<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.email_address }}</p>
              </div>
            </div>
            <!-- phone -->
            <div class="form__row">
              <div class="form__title">
                <label>電話番号</label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.phone_number }}</p>
              </div>
            </div>
            <!-- Select -->
            <div class="form__row">
              <div class="form__title">
                <label>お問い合わせの種類<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.inquiry_detail_type }}</p>
              </div>
            </div>
            <!-- Radio Button -->
            <div class="form__row">
              <div class="form__title">
                <label>返信希望<span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ">{{ this.$props.data?.contact_meta.reply }}</p>
              </div>
            </div>
            <!-- text area -->
            <div class="form__row">
              <div class="form__title">
                <label>お問い合わせ内容 <span class="required">必須</span></label>
              </div>
              <div class="form__content">
                <p class="form__answ answ--inquiry">{{ this.$props.data?.contact_meta.inquiry_detail }}</p>
              </div>
            </div>
            <div class="form__row">
              <div class="form__content">
                <p class="form__note">入力画面に戻る場合は、必ずこの「入力内容を変更する」ボタンをクリックして戻ってください。</p>
              </div>
            </div>
            <div class="form__button">
              <!-- <router-link class="btn btn--white icon--blue" to="/contact/form">修正する</router-link> -->
              <button class="btn btn--white icon--blue" type="button" @click.prevent="backForm">修正する</button>
              <button class="btn btn--send icon--white" type="submit">送信する</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>

</template>

<script>
import { RouterLink } from 'vue-router';
import axios from "axios";

export default {
  name: 'ContactFormConfirm',
  props: ['data'],
  mounted() {
    if(this.$props.data === undefined) {
      this.$router.push({ name: "ContactForm"});
    }
  },
  methods: {
    submitComplete() {
      const contactUrl = process.env.VUE_APP_BASE_URL + "/contact";
      // const contactUrl = 'http://172.16.16.131:8080/wp-json/wp/v2/contact'
        axios.post(contactUrl, this.$props.data,{
          headers: {
            Authorization: `Basic ${process.env.VUE_APP_BASE_TOKEN}`,
          }
        }).then((res) => {
              this.$router.push({ name: "ContactFormComplete",  params: { dataComplete: this.$props.data }})
          })
          .catch((error) => {
            console.log(error);
            alert('SUBMIT FORM ERROR')
          })
    },
    backForm() {
      const dataProp = this.$props.data;
      this.$router.push({ name: "ContactForm", params: { dataProp }});
    }
  }
}
</script>